import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";
import { DataProvider } from "./contexts/dataContext";

const HomeNew = lazy(() => import("./views/Home/HomeNew"));
const Cart = lazy(() => import("./views/Cart/Cart"));
const AfterPayment = lazy(() => import("./views/AfterPayment"));
const PaymentFail = lazy(() => import("./views/PaymentFail"));
const MyOrders = lazy(() => import("./views/Account/MyOrders"));
const OrderDetails = lazy(() => import("./views/Account/OrderDetails"));
const VerifyOTP = lazy(() => import("./views/VerifyOTP"));
const PaymentPage = lazy(() => import("./views/PaymentPage"));

const loadingUI = (
  <div className="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

const App = () => {
  return (
    <DataProvider>
      <Router>
        <Suspense fallback={loadingUI}>
          <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/paymentsuccess" element={<AfterPayment />} />
            <Route path="/paymentfailed" element={<PaymentFail />} />
            <Route path="/myorders" element={<MyOrders />} />
            <Route path="/orderdetails" element={<OrderDetails />} />
            <Route path="/verifyotp" element={<VerifyOTP />} />
            <Route path="/payment" element={<PaymentPage />} />
          </Routes>
        </Suspense>
      </Router>
    </DataProvider>
  );
};

export default App;
